<kendo-appbar class="header p-0 justify-content-between" position="top">
  <kendo-appbar-section class="header-brand" [class.collapsed]="!expanded">
    <a href="javascript:void();">
      @if (expanded) {
        <img alt="Logo" src="assets/media/logos/Relaygrid6_white.svg" class="h-25px h-lg-45px" />
      } @else {
        <img alt="Logo" src="assets/media/logos/logo-icon.svg" class="collapsed-logo" />
      }
    </a>
  </kendo-appbar-section>

  <kendo-appbar-section
    class="container-fluid header-right py-3 py-lg-0 d-flex flex-column flex-lg-row align-items-center justify-content-lg-between"
    >
    <kendo-appbar-section class="page-title d-flex align-items-start flex-column me-5">
      <h1 class="d-flex flex-column text-dark fw-bolder mb-0 fs-3">{{ pagetitle || "" }}</h1>
    </kendo-appbar-section>

    <div class="d-flex">
      <kendo-appbar-section class="d-flex justify-content-end">
        <div class="toggle-fieldset">
          <form [formGroup]="ivrForm" class="d-flex">
            <kendo-formfield class="pe-3 d-flex align-items-center">
              <kendo-switch
                formControlName="forward"
                #forward
                class="w-75-px ivr-switch"
                onLabel="Enabled"
                offLabel="Disabled"
              ></kendo-switch>
            </kendo-formfield>

            @if (!ivrForm.get('forward')?.value) {
              <div class="k-form flex-container">
                <!-- Forwarding is per line; name the line so it's clear which one is forwarding. -->
                <span class="badge bg-success me-2">
                  Forward {{ session.user?.selectedNumber?.name || (session.user?.selectedNumber?.number | phone) }} To
                </span> &nbsp;
                <kendo-textbox
                  class="me-3"
                  formControlName="forwardNumber"
                  style="width: 20em"
                  [clearButton]="true"
                  #forwardNumber
                  >
                  <ng-template kendoTextBoxPrefixTemplate>
                    <em
                      #forwadtNo
                      (click)="help.togglePopup(forwadtNo, 'forward')"
                      class="ms-3 fs-4 fa-duotone fa-forward"
                      help="true"
                    ></em>
                  </ng-template>
                </kendo-textbox>
              </div>
            }
          </form>
        </div>
        <a class="link-primary" style="cursor:pointer"
          (click)="copyAndDial($event)"
          >
          <i class="fa-light fa-phone ms-1 me-2"></i>
        </a>

        <!-- The number badge below only renders while forwarding is disabled, so super-admins
             need a standalone edit affordance for the other case. -->
        @if (canChangeNumber && !ivrForm.get('forward')?.value) {
          <a class="link-primary" style="cursor:pointer" title="Change this phone number"
            (click)="openChangeNumber($event)"
            >
            <i class="fa-duotone fa-pen-to-square ms-1 me-2"></i>
          </a>
        }

        @if (ivrForm.get('forward')?.value) {
          <button
            (click)="numberClick($event)"
            type="button"
            class="btn btn-primary fw-bold number-banner"
            style="font-family: 'Hellix', Helvetica, sans-serif"
            >
            {{ this.session.user!.selectedNumber?.number | phone }}
            @if (this.session.user!.selectedNumber?.name) {
              <span class="ms-3 badge bg-white text-primary">
                {{ this.session.user!.selectedNumber?.name }}</span
                >
              }
              <!-- A <span role="button"> rather than a nested <button>, which is invalid HTML. -->
              @if (canChangeNumber) {
                <span
                  role="button"
                  class="fs-5 ms-4 me-1 fa-duotone fa-pen-to-square"
                  title="Change this phone number"
                  (click)="openChangeNumber($event)"
                ></span>
              } @else {
                <i class="fs-5 ms-4 me-1 fa-duotone fa-pen-to-square"></i>
              }
            </button>
          }

          @if (!ivrForm.get('forward')?.value! || ivrForm.dirty) {
            <button
              kendoButton
              iconClass="fa-duotone fa-floppy-disks"
              class="btn btn-light-primary"
              size="small"
              (click)="UpdateIvrStatus()"
              >
              Save
            </button>
          }
        </kendo-appbar-section>

        <!-- <kendo-appbar-section class="theme-mode-main">
        <button class="btn btn-icon icon-35 btn-light-info" kendoButton #anchor (click)="onThemeToggle()">
          <em *ngIf="!isDarkMode" class="fa-duotone fa-sun-bright light"></em>
          <em *ngIf="isDarkMode" class="fa-duotone fa-moon-stars dark"></em>
          <span class="ms-2 label1">Theme</span>
        </button>

        <kendo-popup
          [anchor]="anchor"
          [margin]="margin"
          (anchorViewportLeave)="showThemePopup = false"
          *ngIf="showThemePopup"
          >
          <div
            class="content p-0 menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-bold theme-mode"
            >
            <ul class="theme-buttons">
              <li class="menu-item">
                <button
                  id="light-theme"
                  class="menu-link light-theme px-3 d-flex"
                  (click)="changeTheme('style.bundle')"
                  >
                  <span class="menu-icon">
                    <em class="fa-duotone fa-sun-bright fs-3 me-3"></em>
                  </span>
                  <span class="menu-title">Light</span>
                </button>
              </li>
              <li class="menu-item">
                <button
                  id="dark-theme"
                  class="menu-link dark-theme px-3 d-flex"
                  (click)="changeTheme('style-dark-bundle')"
                  >
                  <span class="menu-icon">
                    <em class="fa-duotone fa-moon-stars fs-3 me-3"></em>
                  </span>
                  <span class="menu-title">Dark</span>
                </button>
              </li>
            </ul>
          </div>
        </kendo-popup>
      </kendo-appbar-section> -->
    </div>
  </kendo-appbar-section>
</kendo-appbar>

<!-- Change number confirmation (super-admin only) -->
@if (showChangeNumberDialog) {
  <kendo-dialog title="Change Phone Number" [width]="480" (close)="cancelChangeNumber()">
    <div class="p-2">
      <p class="mb-2">
        Repoint <strong>{{ session.user!.selectedNumber?.number | phone: true }}</strong> to a
        different number?
      </p>
      <label class="fs-8 mb-1 d-block">New number</label>
      <kendo-maskedtextbox
        [mask]="phoneMask"
        [(value)]="changeNumberValue"
        [style.width.px]="200"
      ></kendo-maskedtextbox>
      <p class="text-muted fs-8 mb-0 mt-3">
        This rewrites the line's call routing and its menu/extension settings. Past calls, messages
        and clicks stay under the old number.
      </p>
      <p class="text-danger fs-9 mb-0 mt-2">
        <i class="fa-duotone fa-triangle-exclamation me-1"></i>
        Nothing is purchased or released at the carrier — the new number must already be on the
        account, or calls will not reach it.
      </p>
    </div>
    <kendo-dialog-actions>
      <button kendoButton type="button" (click)="cancelChangeNumber()" [disabled]="changeNumberSaving">
        Cancel
      </button>
      <button
        kendoButton
        type="button"
        themeColor="error"
        [disabled]="changeNumberSaving"
        (click)="confirmChangeNumber()"
        >
        @if (changeNumberSaving) {
          <i class="fa-duotone fa-spinner fa-spin me-2"></i>Changing…
        } @else {
          <i class="fa-duotone fa-pen-to-square me-2"></i>Change number
        }
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
